import { Calendar, Filter, Menu, Moon, PanelLeft, Search, Sun } from 'lucide-react';
import { useDataset } from '../api/hd';
import { COMPARES, PERIODS, useFilters } from '../stores/filters';
import { useUi } from '../stores/ui';
import { MultiMenu, SelectMenu } from './Menu';
import { UserMenu } from './UserMenu';
import { AlertsButton } from './AlertsButton';

export function TopBar({ onMenu }: { onMenu: () => void }) {
  const { period, compare, channels, setPeriod, setCompare, setChannels } = useFilters();
  const theme = useUi((s) => s.theme);
  const toggleTheme = useUi((s) => s.toggleTheme);
  const toggleSidebar = useUi((s) => s.toggleSidebar);
  const setPalette = useUi((s) => s.setPaletteOpen);
  const families = useDataset('families').data ?? [];
  return (
    <header className="topbar">
      <button type="button" className="icon-btn menu-btn" aria-label="Open navigation" onClick={onMenu}>
        <Menu size={20} />
      </button>
      <button type="button" className="icon-btn hide-phone" aria-label="Collapse sidebar" onClick={toggleSidebar}>
        <PanelLeft size={18} />
      </button>
      <div className="topbar-filters" role="toolbar" aria-label="Report filters">
        <SelectMenu
          label="Period"
          icon={<Calendar size={14} />}
          value={period}
          options={PERIODS.map((p) => ({ value: p.id, label: p.label }))}
          onChange={setPeriod}
        />
        <SelectMenu
          label="Compare to"
          prefix="Compare to"
          value={compare}
          options={COMPARES.map((c) => ({ value: c.id, label: c.label }))}
          onChange={setCompare}
        />
        <MultiMenu
          label="Channels"
          icon={<Filter size={14} />}
          allLabel="All channels"
          value={channels}
          options={families.map((f) => ({ value: f.id, label: f.label }))}
          onChange={setChannels}
        />
      </div>
      <div className="topbar-actions">
        <button type="button" className="icon-btn" aria-label="Search (Ctrl+K)" onClick={() => setPalette(true)}>
          <Search size={18} />
        </button>
        <AlertsButton />
        <button
          type="button"
          className="icon-btn"
          aria-label={theme === 'dark' ? 'Switch to light appearance' : 'Switch to dark appearance'}
          onClick={toggleTheme}
        >
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <UserMenu />
      </div>
    </header>
  );
}
